import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalTripComponent } from './component/approval-trip/approval-trip.component';
import {ApprovalTripService} from './approval-trip.service';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {DirectivesModule} from '../../../directives/directives.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AppealTripComponent } from './component/appeal-trip/appeal-trip.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Trip2ThemeModule,
    DirectivesModule,
  ],
  declarations: [ApprovalTripComponent, AppealTripComponent],
  exports: [
    ApprovalTripComponent,
    AppealTripComponent
  ],
  providers: [ApprovalTripService]
})
export class ApprovalTripModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/approval-trip/approval-trip.module.ts